export default {
  state: {docParentPageStatus: {}, },
  mutations: {
    UPDATE_CACHE: (state, data) => {
      if (data && Object.keys(data).length > 0) {
        Object.keys(data).forEach(key => {
          state.docParentPageStatus[key] = data[key];
        });
      }
    },
    CLEAR_CACHE: (state, data) => {
      state.docParentPageStatus = {};
    }
  },
  actions: {
    updateStatusCache({commit}, data) {
      if (data) {
        commit('UPDATE_CACHE', data);
      }
    },
    clearStatusCache({commit}) {
      commit('CLEAR_CACHE');
    },
  },
};
